module.exports = __webpack_public_path__ + "img/bcg-offer.9ecd5950.jpg";